import { useLendingApplicationID } from "@lending/hooks/useLendingApplicationID";
import { useApi } from "@lending/lib/api";

function useListPersonalLoanOffersQuery() {
  const $api = useApi();
  const lendingApplicationID = useLendingApplicationID();

  return $api.useQuery(
    "get",
    "/v2/lending/personal_loan_offers/",
    {
      params: {
        query: {
          application: lendingApplicationID,
        },
      },
    },
    {
      enabled: Boolean(lendingApplicationID),
    }
  );
}

export { useListPersonalLoanOffersQuery };
